import React, { Component } from "react"
import { Button, Glyphicon } from "react-bootstrap"
import Ajax from "superagent"


/**
 * Note: idk why this doesn't work with credentials: same origin
 * i need to use the "api key"
 */

class UpdateUberPage extends Component {
  constructor(props, context) {
    super(props, context)
    this.state = {
      tokensData: {}
    }
  }

  componentDidMount() {
    Ajax
      .get("/uberapi/getTokensData")
      .then(res => {
        this.setState({tokensData: res.body})
      })
  }

  render() {
    const {tokensData} = this.state
    return (
      <div style={{padding: 20}}>
        <div>tokenExpiration: {tokensData.tokenExpiration}</div>
        <div>lastRefresh: {tokensData.lastRefresh}</div>
        <Button style={{marginTop: "10px"}} onClick={() => window.location = "/uberapi/uberlogin"}>
          <Glyphicon glyph="refresh" />
            Actualizar
        </Button>
      </div>
    )
  }
}
  
export default UpdateUberPage


// WEBPACK FOOTER //
// ./src/app/admin/components/UpdateUberPage.jsx